import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input, type InputProps } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export interface PasswordFieldProps extends Omit<InputProps, "type"> {
  toggleAriaLabel?: string;
}

export default function PasswordField({
  className,
  toggleAriaLabel,
  ...props
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const label =
    toggleAriaLabel ??
    (visible ? t("common.hide_password") : t("common.show_password"));

  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        className={cn("pr-10", className)}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={label}
        aria-pressed={visible}
        className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
